// extracted by mini-css-extract-plugin
module.exports = {"ad-wrapper":"organism1-m__ad-wrapper__1BwQR","load-more-view":"organism1-m__load-more-view__3vlLS"};